// extracted by mini-css-extract-plugin
module.exports = {"header":"ParentEditPage_header__2S3SY"};